
















































//import Vue from "vue";
//import * as Sentry from "@sentry/browser";
import { Component, Watch, Mixins  } from "vue-property-decorator";
import { auth } from "@/scripts/firebase";
import { ActionLinkParams} from "@/scripts/datatypes";
import firebase from "firebase";
import Sidebar from "@/components/Sidebar.vue";
import Notice from "@/components/Notice.vue";
//import VueRouter, { Route } from 'vue-router';
import { localize } from 'vee-validate';
import Common from '@/mixins/common';
import moment from 'moment-timezone'

/**
 * userMetaとmaritoMeta監視
 */

@Component({
  components: {
    Notice,
    Sidebar,
  }
})

export default class App extends Mixins(Common) {
  authObservers: (firebase.Unsubscribe | undefined)[] = []
  docObservers: (firebase.Unsubscribe | undefined)[] = []
  //school?: School
  showNotice = true
  
  setLang(lang: string){
    if(this.$i18n.messages[lang]){
      this.$store.commit('setLang', lang);
      this.$i18n.locale = lang
      auth.languageCode = lang
      document.documentElement.lang = lang
      localize(lang)
      moment.locale(lang)
      return true
    }
    return false
  }

  setMeta(){
    if(! this.$route.name){
      return
    }

    let title = this.$t('serviceName.marito') as string

    if(this.$store.getters.actionLinkMode){
      title += ' ' + this.$t(`actionLink.mode.${this.$store.getters.actionLinkMode}`)
    }else{
      title += ' ' + this.$t(`pageTitle.${this.$route.name}`)
    }

    document.title = title
    
    const metaDescription = document.querySelector("meta[name='description']")
	
    if(! metaDescription){
      return
    }

		if(this.$route.meta.description){
      metaDescription.setAttribute('content',this.$t(`description.${this.$route.meta.description}`) as string)
      return
    }
    
    if(this.$router && this.$router.options && this.$router.options.routes){
      const routeHome = this.$router.options.routes.find((route) => {return route.path === '/' && route.meta.description})
      if(routeHome){
        metaDescription.setAttribute('content',this.$t(`description.${routeHome.meta.description}`) as string)
      }
    }
  }

  setDefaultLang(){
    const language = (window.navigator.languages && window.navigator.languages[0]) || window.navigator.language
    const lang = (language || "").substr(0, 2);

    if(! this.setLang(lang)) {
      this.setLang(this.$i18n.locale)
    }

    if(this.$route.query.lang){
      this.setLang(this.$route.query.lang as string)
    }
  }

  setActionLinkParams(){
    const params = {} as ActionLinkParams
    if(this.$route.query && this.$route.query.mode && this.$te(`actionLink.mode.${this.$route.query.mode}`) && this.$route.query.oobCode){
      params.mode = this.$route.query.mode as string
      params.actionCode = this.$route.query.oobCode as string
    }
    this.$store.commit('setActionLink',params)
  }

  async created() {
    console.trace('created')
    this.setDefaultLang()
    this.setActionLinkParams()
    /**
     * isLoadingの扱い
     */

    //this.$store.watch(
    //  (state, getters) => getters.loading,
    //  (newValue, oldValue) => {
        /*
        if(this.loadingComponent){
          this.loadingComponent.close()
        }
         if(newValue){
          this.loadingComponent = this.$buefy.loading.open({})
         }
         */
    //  }
    //)


    this.authObservers.push(auth.onIdTokenChanged(async user => {
      console.log("idTokenChanged:")

      if(user && user.uid){
        try{
          this.$store.commit("setLoading",true);

          const idToken = await user.getIdTokenResult()
          if(typeof idToken.claims.schools === 'object'){
            
            this.$store.commit("setCustomClaims", idToken.claims)
            const schoolIds = Object.keys(this.$store.getters.schools);
            if(! this.$store.getters.schoolId || ! schoolIds.includes(this.$store.getters.schoolId)){
              //いつか最終アクセス日順にかえる
              this.$store.commit("setSchoolId", schoolIds[0]);
            }

          }else{
            console.log("idTokenChanged: null");
            this.$unsubscriber(this.docObservers)
            this.$store.commit("setCustomClaims", null);
            this.$store.commit("setSchoolId",null);
          }
        }catch(error){
          console.error("getIdTokenResult", error);
        }finally{
          this.$store.commit("setLoading",false);
        }
      }else{
        console.log("idTokenChanged: null");
        this.$unsubscriber(this.docObservers)
        this.$store.commit("setCustomClaims", null);
        this.$store.commit("setSchool",null);
      }
    }));

    this.authObservers.push(auth.onAuthStateChanged(async (user) => {
      console.log("authStateChanged:");
      if(user && user.uid){
        this.$store.commit("setUser",user);
      }else{
        this.$store.commit("setUser", null);
      }
    }));
  }

  mounted(){
    console.trace('mounted');
  }

  get signIn(): boolean {
    return !! this.$store.getters.uid
  }
  
  get signedIn(): boolean {
    return !! (this.$store.getters.schoolId && this.$store.getters.uid && this.$store.state.school && this.$store.state.userPrivateProfile && this.$store.state.userPublicProfile)
  }

  get authorized(): boolean {
    return this.$store.getters.disabled !== true && this.$route.meta.accessLevel && (this.$route.meta.accessLevel <= this.$store.getters.accessLevel)
  }

  get isPublic(): boolean{
    return !! this.$route.meta.public
  }

/*
  get notAuthorized(): boolean{
    return (! this.isPublic && this.signIn && ! this.authorized)
  }
*/

  get is404(){
    return (this.$route.name === 'notFound') ? true : false
  }

  @Watch('routePath')
  changeRoutePath(routePath: string){
    this.setMeta()
  }

  @Watch('userLang')
  changeUserLang(userLang: string){
    this.setLang(userLang)
    this.setMeta()
  }

  @Watch('lang')
  changeLang(lang: string){
    this.setMeta()
  }

  @Watch('schoolId')
  changeSchoolId(schoolId: string){
    this.$unsubscriber(this.docObservers)

    if(! schoolId){
      return
    }
    this.setObservers()
  }

  async setObservers(){
    const schoolPublicProfileDocRef = this.$getSchoolPublicProfileDocRef()

    this.docObservers.push(schoolPublicProfileDocRef.onSnapshot( (snapshot) => {
      if(snapshot.exists){
        this.$store.commit("setSchool", snapshot.data());
      }else{
        this.$store.commit("setSchool", null);
      }
    }))

    const userPublicProfileDocRef = this.$getUserPublicProfileDocRef()
    
    this.docObservers.push(userPublicProfileDocRef.onSnapshot((snapshot) => {
      if(snapshot.exists){
        this.$store.commit("setUserPublicProfile", snapshot.data());
      }else{
        this.$store.commit("setUserPublicProfile", null);
      }
    }))

    const userPrivateProfileDocRef = this.$getUserPrivateProfileDocRef()

    this.docObservers.push(userPrivateProfileDocRef.onSnapshot((snapshot) => {
      if(snapshot.exists){
        this.$store.commit("setUserPrivateProfile", snapshot.data());
      }else{
        this.$store.commit("setUserPrivateProfile", null);
      }
    }))
  }
  
  get routePath(): string {
    return this.$route.path
  }

  get userLang(): string {
    return this.$store.getters.userLang
  }

  get lang(): string {
    return this.$store.getters.lang
  }

  get schoolId(): string {
    return this.$store.getters.schoolId
  }

  destroyed() {
    this.$unsubscriber(this.authObservers)
    this.$unsubscriber(this.docObservers)
    console.trace('destroyed');
  }
}
